export default __webpack_public_path__ + "static/roles-c247d492096c9a39f28d4c21c8294135.jpg";